import { NavItemProps } from '@components/Navigation';
import { LinkProps } from '@repo/ui/src/types';
import React from 'react';

export const useKeyboardNavigation = ({
  items,
  onChange,
}: {
  items: Array<NavItemProps | LinkProps>;
  onChange: (index: number) => void;
}) => {
  const getNextIndex = (index: number, direction: 'ArrowLeft' | 'ArrowRight') => {
    if (direction === 'ArrowLeft') {
      return index > 0 ? index - 1 : items.length - 1;
    }
    if (direction === 'ArrowRight') {
      return index < items.length - 1 ? index + 1 : 0;
    }
    return index;
  };

  return (e: React.KeyboardEvent) => {
    const index = Number((e.currentTarget as HTMLElement).dataset.index);
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      const nextIndex = getNextIndex(index, e.key);
      e.preventDefault();
      onChange(nextIndex);
    }
  };
};
